<style>
  .line-height20{
    line-height: 19px;
  }
</style>
<template>
  <div class="revisePhone-box">
    <div class="shade-box ">
      <div class="shade-content position-top">
        <p class="dialog-title-bg line-height20">修改绑定电话
        <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="cancelRevisePhone('revisePhoneForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="reviseForm" ref="revisePhoneForm" label-width="100px" class="demo-ruleForm" :rules="$rules">
            <el-form-item label="手机号" prop="userPhone">
              <el-input v-model="reviseForm.userPhone" placeholder="请输入新手机号" maxlength="11" ref="userPhoneInput" auto-complete="off" @blur="msgShow"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="codeImg">
              <el-input class="code" v-model="reviseForm.codeImg" auto-complete="off" placeholder="请输入验证码" maxlength="6" @blur="msgShow"></el-input>
              <img :src="'data:image/gif;base64,' + imgCode" class="img-code" @click="getImgCode" v-if="imgCode">
            </el-form-item>
            <el-form-item label="短信验证码" prop="msgCode" v-if="show">
              <el-input class="code" v-model="reviseForm.msgCode" placeholder="请输入短信验证码" maxlength="6" auto-complete="off" @keyup.enter.native="submitForm('revisePhoneForm')"></el-input>
              <span @click="getMsgCode" class="img-code get-code" v-show="MsgCodeTextShow">获取短信验证码</span>
              <span v-show="!MsgCodeTextShow" class="img-code get-code">{{count}} s后可重新获取</span>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('revisePhoneForm')" :disabled="disabled">确认修改</el-button>
              <el-button @click="cancelRevisePhone('revisePhoneForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "revisePhone",
  data(){
    return{
      disabled: false,
      MsgCodeTextShow: true,
      count: '',//倒计时
      timer: null,//定时器
      show: false,
      imgCode: '',
      reviseForm: {
        userPhone: '',
        codeImg: '',
        imagetoken: '',
        msgCode: '',
      },
    };
  },
  created(){
    this.$nextTick(function(){
      this.$refs.userPhoneInput.focus();
    });
    this.getImgCode();
  },
  methods: {
    getImgCode(){//获取图片验证码
      api.getMsgCode({parms: {}}).then(res => {
        if(res.status == 'success'){
          this.imgCode = res.data.img;
          this.reviseForm.imagetoken = res.data.imagetoken;
        }
      })
    },
    msgShow(){
      if(this.reviseForm.userPhone & this.reviseForm.codeImg){
        if (!/(1[345789]\d{9})/.test(this.reviseForm.userPhone)) {
          this.$message.error('手机号不正确！');
          this.show = false;
        }else{
          this.show = true;
        }
      }else{
        this.show = false;
      }
    },
    getMsgCode(){
      this.MsgCodeTextShow = false;
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
        } else {
          this.MsgCodeTextShow = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000)
      let data = {
        "userPhone": [this.reviseForm.userPhone],
        "type": 3,//1.登录 2. 注册 3.修改 4.忘记密码
        "verifyCode": this.reviseForm.codeImg,//验证码
        "imagetoken": this.reviseForm.imagetoken,//验证码token
      }
      api.getCode({data:data}).then(res =>{
        if(res.status == 'success'){
          this.$message.success('发送成功，请注意查收短信');
        }
      })
    },
    submitForm(formName){//修改
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
          }
          this.disabled = true;
          let data = {
            "userPhone": this.reviseForm.userPhone,
            "msgCode": this.reviseForm.msgCode,
          }
          api.updateUserPhone({data:data}).then(res => {
            this.disabled = false;
            if(res.status == 'success'){
              this.$message.success(res.msg);
              this.cancelRevisePhone('revisePaddForm');
            }
          })
        } else {
          return false;
        }
      });
    },
    cancelRevisePhone(formName){//取消修改
      this.$refs[formName].resetFields();
      this.$emit('colsePhone')
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/layout/revisePhone.vue